import FilterToggleGroup from 'marketplace-ui-common/filters/components/filterToggleGroup/FilterToggleGroup';
import { DEFAULT_APP_SORT_FIELD, DEFAULT_APP_SORT_ORDER } from '../constants/sortConstants';
import { getAppSortOptionValue, getAppSortOptions, parseAppSortOptionValue } from '../utils/sortUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export function AppSortToggleGroup({
  onChange,
  value
}) {
  return /*#__PURE__*/_jsx(FilterToggleGroup, {
    multi: false,
    name: "appSorts",
    onChange: event => {
      const {
        sortField,
        sortOrder
      } = parseAppSortOptionValue(event.target.value);
      onChange({
        sortField,
        sortOrder
      });
    },
    options: getAppSortOptions(),
    value: getAppSortOptionValue((value === null || value === void 0 ? void 0 : value.sortField) || DEFAULT_APP_SORT_FIELD, (value === null || value === void 0 ? void 0 : value.sortOrder) || DEFAULT_APP_SORT_ORDER)
  });
}